import { EngineRenderers } from '@websky/core/src/renderProps';

import CheckoutCurrencyWarning from './components/CurrencyWarning/CurrencyWarning';
import SeatMap from './components/SeatMap/SeatMap';
import Seat from './components/SeatMap/Seat/Seat';
import CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService';
import FlightInfoIcon from 'components/FlightInfoIcon/FlightInfoIcon';
// import FfpInfo from './components/Loyalty/FfpInfo/FfpInfo';
import OrderInsuranceBlockSlotUpsale from '@websky/core/src/Checkout/components/Checkout/OrderInsuranceBlockSlot/OrderInsuranceBlockSlot.upsale';
import Order from './components/Checkout/Order/Order';
import BaggageIcon from './components/Baggage/BaggageIcon/BaggageIcon';
import MealServiceWrapper from './components/MealService/Wrapper/Wrapper';
import CheckinServicesV2 from '@websky/core/src/Modules/Checkin/components/Checkin/AdditionalServices/AdditionalServices';
import FirstLoginAgreement from './components/LoginPage/FirstLoginAgreement/FirstLoginAgreement';

export const renders: EngineRenderers = {
	BaggageIcon,
	CheckoutCurrencyWarning: CheckoutCurrencyWarning,
	SeatMapService: SeatMap,
	SeatMapSeat: Seat,
	CheckoutAdditionalService: {
		CheckoutAdditionalService
	},
	renderFlightInfoIcon: FlightInfoIcon,
	// FfpInfoStatuses: FfpInfo,
	MealServiceWrapper,
	CheckoutInsurance: OrderInsuranceBlockSlotUpsale,
	renderOrderRoute: Order,
	CheckinServices: CheckinServicesV2,
	FirstLoginAgreement
};
